import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from "react";
import { Header } from "./common/Header";
import { Footer } from "./common/Footer";
import { Services } from "./pages/Services";
import { Home } from "./pages/Home";
import { AboutUs } from "./pages/AboutUs";
import { OurProducts } from "./pages/OurProducts";
import { OnionPage } from "./pages/products/OnionPage";
import { ContactUs } from "./pages/ContactUs";
import { CashewnutsPage } from "./pages/products/CashewnutsPage";
import { RoastedPeanutsPage } from "./pages/products/RoastedPeanutsPage";
import { NaturalHoneyPage } from "./pages/products/NaturalHoneyPage";
import { PomegranatePage } from "./pages/products/PomegranatePage";
import { Certifications } from "./pages/Certifications";
import ScrollToTop from "./pages/ScrollToTop";
import { PeanutsPage } from "./pages/products/PeanutsPage";
import { Peanuts } from "./pages/products/Peanuts";
import { PsylliumHusk } from "./pages/products/PsylliumHusk";
import { G9Banana } from "./pages/products/G9Banana";
import { PeanutButter } from "./pages/products/PeanutButter";
import { CumminSeedsPage } from "./pages/products/CumminSeedsPage";
import { Certificate } from "./pages/Certificate";
// import PeanutsPage from "./pages/products/PeanutsPage";

export const Pages = () => {
  return (
    <>
      <Router>
        <Header />
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/productpage" element={<OurProducts />} />
          <Route path="/service" element={<Services />} />
          <Route path="/certificate" element={<Certificate />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/onion" element={<OnionPage />} />
          <Route path="/peanuts" element={<Peanuts/>} />
          <Route path="/psylliumhusk" element={<PsylliumHusk />} />
          <Route path="/banana" element={<G9Banana />} />
          <Route path="/products/:productname" element={<PeanutsPage />} />
          <Route path="/cummin" element={<CumminSeedsPage />} />

          <Route path="/cashewnuts" element={<CashewnutsPage />} />
          <Route path="/peanutbutter" element={<PeanutButter />} />
          <Route path="/honey" element={<NaturalHoneyPage />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
};
